import { CalendarDateProps } from '~/src/common/components/CalendarDate/CalendarDate';
import dayjs from '~/src/common/services/Date';

/**
 * Pour les DLCs lointains on affiche annee + mois
 * Pour les DLCs proches on affiche mois + jour
 */
export const getProductUseByCalendarDate = (date: number): CalendarDateProps => {
  const parsed = dayjs(date);

  if (parsed.diff(new Date(), 'month') > 2)
    return {
      header: parsed.format('YYYY'),
      value: parsed.format('MMM'),
    };

  return {
    header: parsed.format('MMM'),
    value: parsed.format('DD'),
  };
};
